import "core-js/modules/es.array.push.js";
import { queryDocTemplate, changeTemplateStatus } from '@/api/notice/documentApi.js';
export default {
  data: function data() {
    var _this = this;
    return {
      form: {
        name: undefined,
        status: undefined,
        typeId: undefined
      },
      columns: [{
        title: '序号',
        dataIndex: 'rowNumber',
        align: 'center',
        width: '150px'
      }, {
        title: '模板名称',
        dataIndex: 'name',
        align: 'center',
        width: '500px'
      }, {
        title: '模板类型',
        dataIndex: 'type',
        align: 'center',
        width: '120px',
        scopedSlots: {
          customRender: 'type'
        }
      }, {
        title: '状态',
        dataIndex: 'status',
        align: 'center',
        width: '120px',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: '120px',
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      tableData: [],
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 19
      },
      paginationTable: {
        total: 0,
        defaultPageSize: 10,
        showTotal: function showTotal(total) {
          return "\u5171 ".concat(total, " \u6761\u6570\u636E");
        },
        showSizeChanger: true,
        pageSizeOptions: ['10', '15', '20'],
        onShowSizeChange: function onShowSizeChange(current, pageSize) {
          return _this.pageSize = pageSize;
        }
      }
    };
  },
  methods: {
    loadData: function loadData() {
      var _this2 = this;
      queryDocTemplate(this.form).then(function (res) {
        if (res.data.code == 200) {
          _this2.tableData = res.data.data.rows;
        }
      });
    },
    handleSubmit: function handleSubmit() {
      this.loadData();
    },
    viewClick: function viewClick(row) {
      this.$router.push({
        path: '/docNotice/doc/doctemplateEdit',
        query: {
          mode: 'view',
          data: row
        }
      });
    },
    editClick: function editClick(row) {
      this.$router.push({
        path: '/docNotice/doc/doctemplateEdit',
        query: {
          mode: 'edit',
          data: row
        }
      });
    },
    statusChange: function statusChange(id, status) {
      var _this3 = this;
      var req = {
        id: id
      };
      if (status === 1) {
        req.status = 0;
        changeTemplateStatus(req).then(function (res) {
          if (res.data.code == 200) {
            _this3.$message.success('停用成功');
            _this3.loadData();
          }
        });
      } else if (status === 0) {
        req.status = 1;
        changeTemplateStatus(req).then(function (res) {
          if (res.data.code == 200) {
            _this3.$message.success('启用成功');
            _this3.loadData();
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};